export default __webpack_public_path__ + "static/media/AcornMallFastFood_34.28a17417.png";